<template>
    <div>
        <a-drawer
            :title="$t('program.import_program_details_drawer.title' /* 日程导入详情 */)"
            width="70%"
            placement="right"
            :closable="true"
            :body-style="{ height: 'calc(100vh - 57px)', paddingBottom: '50px', overflow: 'auto' }"
            :visible="visible"
            @close="handleCloseEvent"
        >
            <a-spin :spinning="loading">
                <a-collapse v-model="activeKey">
                    <a-collapse-panel v-for="(item, index) in list" :key="index.toString()">
                        <div class="flex x-between y-center" slot="header">
                            <div class="flex x-left">
                                <div class="mr20">
                                    <span class="color000">{{ $t('program.import_program_details_drawer.date' /* 日期 */) }}：</span>
                                    <span class="color666">{{ item.date }} {{ item.time_range }}</span>
                                </div>
                                <div>
                                    <span class="color000">{{ $t('program.import_program_details_drawer.venue' /* 会场 */) }}：</span>
                                    <span class="color666">{{ item.venue }}</span>
                                </div>
                            </div>
                            <div>
                                <a-button v-if="info.status != 3 && info.status != -2" type="primary" size="small" @click="handleClickEvent">
                                    {{ formatBtnTxtFun(info.status) }}
                                </a-button>
                            </div>
                        </div>

                        <div>
                            <span class="color000">Session：</span>
                            <span class="color666">{{ item.session_title }}</span>
                        </div>
                        <div class="mt10">
                            <a-badge :color="formatStatusColorFun(info.status)" :text="formatStatusFun(info.status)" />
                            <span class="ml10" style="color: #f00" v-if="info.status == '-3'">{{ info.remark }}</span>
                        </div>
                        <!-- 角色列表 -->
                        <a-table
                            v-for="role in getRolesTypeList(item.roles)"
                            :key="role.type"
                            class="mt10"
                            bordered
                            :rowKey="(Record, index) => index"
                            :columns="columns"
                            :data-source="role.list"
                            size="small"
                            :scroll="{ x: 680 }"
                            :pagination="false"
                        >
                            <template slot="title">
                                <span class="color000">{{ role.type }}：</span>
                            </template>
                            <template slot="status">
                                <a-badge :color="formatStatusColorFun(info.status)" :text="formatStatusFun(info.status)" />
                            </template>
                            <template slot="remark">
                                <span>{{ info.remark }}</span>
                            </template>
                        </a-table>
                        <!-- 讲者列表 -->
                        <a-table class="mt10" bordered :rowKey="(Record, index) => index" :columns="columns1" :data-source="item.speakers" size="small" :scroll="{ x: 1000 }" :pagination="false">
                            <template slot="title">
                                <span class="color000">{{ $t('program.import_program_details_drawer.speaker' /* 讲者 */) }}：</span>
                            </template>
                            <template slot="status">
                                <a-badge :color="formatStatusColorFun(info.status)" :text="formatStatusFun(info.status)" />
                            </template>
                            <template slot="remark">
                                <span>{{ info.remark }}</span>
                            </template>
                        </a-table>
                    </a-collapse-panel>
                </a-collapse>
            </a-spin>

            <div
                class="t-r"
                :style="{
                    position: 'absolute',
                    left: '0px',
                    bottom: '0px',
                    height: '50px',
                    width: '100%',
                    borderTop: '1px solid #e9e9e9',
                    padding: '10px 16px',
                    background: '#fff',
                    textAlign: 'right',
                    zIndex: '100'
                }"
            >
                <a-button type="default" @click="handleCloseEvent">{{ $t('web.cancel' /* 取消 */) }}</a-button>
                <a-button class="ml10" type="primary" @click="handleSaveEvent('save')">{{ $t('program.import_program_details_drawer.save' /* 保存 */) }}</a-button>
            </div>
        </a-drawer>
        <!-- 新增导入任务 -->
        <add-import-program-modal ref="addImportProgramModal" @refresh="handleRefreshFun" />
    </div>
</template>
<script>
import AddImportProgramModal from './add-import-program-modal.vue';
export default {
    name: 'ImportProgramDetailsDrawer',
    components: {
        AddImportProgramModal
    },
    data() {
        return {
            visible: false,
            loading: false,
            columns: [
                {
                    title: this.$t('program.import_program_details_drawer.name' /* 姓名 */),
                    dataIndex: 'name',
                    width: 80
                },
                {
                    title: this.$t('program.import_program_details_drawer.unit' /* 单位 */),
                    dataIndex: 'unit',
                    width: 150
                },
                {
                    title: this.$t('program.import_program_details_drawer.phone' /* 电话 */),
                    dataIndex: 'phone',
                    width: 100
                },
                {
                    title: this.$t('program.import_program_details_drawer.email' /* 邮箱 */),
                    dataIndex: 'email',
                    width: 100
                },
                {
                    title: this.$t('program.import_program_details_drawer.status' /* 状态 */),
                    dataIndex: 'status',
                    width: 150,
                    scopedSlots: { customRender: 'status' },
                    align: 'center'
                },
                {
                    title: this.$t('program.import_program_details_drawer.remark' /* 备注 */),
                    dataIndex: 'remark',
                    width: 150,
                    align: 'center'
                }
            ],
            columns1: [
                {
                    title: this.$t('program.import_program_details_drawer.duration' /* 时长 */),
                    dataIndex: 'duration',
                    width: 80
                },
                {
                    title: this.$t('program.import_program_details_drawer.type' /* 发言类型 */),
                    dataIndex: 'type',
                    width: 100
                },
                {
                    title: this.$t('program.import_program_details_drawer.title' /* 题目 */),
                    dataIndex: 'title',
                    width: 150
                },
                {
                    title: this.$t('program.import_program_details_drawer.speaker' /* 讲者 */),
                    dataIndex: 'name',
                    width: 80
                },
                {
                    title: this.$t('program.import_program_details_drawer.unit' /* 单位 */),
                    dataIndex: 'unit',
                    width: 150
                },
                {
                    title: this.$t('program.import_program_details_drawer.phone' /* 手机 */),
                    dataIndex: 'phone',
                    width: 100
                },
                {
                    title: this.$t('program.import_program_details_drawer.email' /* 邮箱 */),
                    dataIndex: 'email',
                    width: 100
                },
                {
                    title: this.$t('program.import_program_details_drawer.article_id' /* 文章ID号 */),
                    dataIndex: 'article_id',
                    width: 80
                },
                {
                    title: this.$t('program.import_program_details_drawer.status' /* 状态 */),
                    dataIndex: 'status',
                    width: 150,
                    scopedSlots: { customRender: 'status' },
                    align: 'center'
                },
                {
                    title: this.$t('program.import_program_details_drawer.remark' /* 备注 */),
                    dataIndex: 'remark',
                    width: 150,
                    align: 'center'
                }
            ],
            list: [],
            info: {},
            activeKey: ['0']
        };
    },
    methods: {
        show(task_id) {
            this.visible = true;
            this.getDataList(task_id);
        },
        handleCloseEvent() {
            this.activeKey = ['0'];
            this.list = [];
            this.info = {};
            this.visible = false;
        },
        /**
         * 格式化按钮状态
         * @param {string} status 任务状态
         * @returns {string} 任务状态
         */
        formatBtnTxtFun(status) {
            switch (status) {
                case '4':
                    return this.$t('program.import_program_details_drawer.checking' /* 校验中 */);
                case '0':
                    return this.$t('program.import_program_details_drawer.check_data_integrity' /* 校验数据完整性 */);
                case '1':
                    return this.$t('program.import_program_details_drawer.confirm_import' /* 确认导入 */);
                case '2':
                    return this.$t('program.import_program_details_drawer.import' /* 导入中 */);
                case '-3':
                    return this.$t('program.import_program_details_drawer.reupload' /* 重新上传 */);
            }
        },
        /**
         * 格式化任务状态颜色
         * @param {string} status 任务状态
         * @returns {string} 任务状态颜色
         */
        formatStatusColorFun(status) {
            switch (status) {
                case '-1':
                    return '#ddd';
                case '0':
                    return '#FFC125';
                case '1':
                    return 'gold';
                case '2':
                    return 'yellow';
                case '3':
                    return 'green';
                case '-2':
                    return 'red';
                case '-3':
                    return 'red';
                default:
                    return '#ddd';
            }
        },
        /**
         * 格式化状态文字
         * @param {string} status 任务状态
         * @returns {string} 任务状态
         */
        formatStatusFun(status) {
            switch (status) {
                case '-1':
                    return this.$t('program.import_program_details_drawer.deleted' /* 已删除 */);
                case '0':
                    return this.$t('program.import_program_details_drawer.waiting_for_verification' /* 待校验 */);
                case '1':
                    return this.$t('program.import_program_details_drawer.waiting_for_import' /* 待导入 */);
                case '2':
                    return this.$t('program.import_program_details_drawer.importing' /* 导入中 */);
                case '3':
                    return this.$t('program.import_program_details_drawer.import_success' /* 导入成功 */);
                case '-2':
                    return this.$t('program.import_program_details_drawer.import_failed' /* 导入失败 */);
                case '-3':
                    return this.$t('program.import_program_details_drawer.check_failed' /* 校验失败 */);
            }
        },
        /**
         * 获取数据列表
         */
        getDataList(task_id) {
            this.loading = true;
            this.$request
                .get({ url: 'getProgramImportInfo', data: { task_id } })
                .then(res => {
                    this.info = res.data;
                    this.list = JSON.parse(res.data.parse_json);
                    console.log(this.list);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        /**
         * 获取角色类型列表
         * @param arr 角色类型列表
         */
        getRolesTypeList(arr) {
            // 获取所有唯一的type
            const uniqueTypes = [...new Set(arr.map(item => item.type))];
            // 构造新数组，每个type只出现一次，list为该type的所有数据项
            const result = uniqueTypes.map(type => ({
                type,
                list: arr.filter(item => item.type === type)
            }));
            return result;
        },
        /**
         * 处理导入日程数据
         */
        handleClickEvent() {
            // 阻止事件冒泡
            event.stopPropagation();
            if (this.info.status == -3) {
                this.$refs.addImportProgramModal.show(this.info.id);
                return;
            }
            this.$request.post({ url: 'setProgramImportData', data: { task_id: this.info.id } }).then(res => {
                const { code, data, message } = res;
                if (code == 200) {
                    this.$message.success(message);
                    this.$emit('refresh');
                    this.visible = false;
                } else {
                    this.$message.error(message);
                }
            });
        },
        /**
         * 刷新
         */
        handleRefreshFun() {
            this.$emit('refresh');
            this.visible = false;
        }
    }
};
</script>
<style lang="less" scoped>
:deep(.ant-table-thead) {
    background: #fafafa;
}
</style>
